exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-297fa1b8]{font-size:1.25rem;line-height:1.25rem;color:#494949;font-weight:500}@media (max-width:575px){p[data-v-297fa1b8]{font-size:1.125rem;line-height:1.125rem}}.radio-check-heading[data-v-297fa1b8]{margin-bottom:0}", ""]);

// exports
